export default "__VITE_ASSET__BLkL39gN__"